import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';

export type ISurchargeInfoBlockData = Catalog.IBlockData<ISurchargeInfoBlockContent>;

export interface ISurchargeInfoBlockContent {
    text: string;
    linkText?: string;
    url?: string;
}

@ICmsComponent<SurchargeInfoBlockComponent>({
    id: 'surcharge-info-block',
    block: {
        url: 'surcharge-info-block'
    },
    name: 'Surcharge Info Block',
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'text',
            title: 'Text',
            required: true
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'linkText',
            title: 'Link text'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'url',
            title: 'Url'
        }
    ]
})
@Component({
    selector: 'surcharge-info-block',
    templateUrl: './surcharge-info-block.html',
    styleUrls: ['surcharge-info-block.scss'],
    standalone: true,
    imports: [ICmsClientModule, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SurchargeInfoBlockComponent extends UiComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: ISurchargeInfoBlockContent;

    @Input()
    variant?: string;
}
